//
// Copyright 2021 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React from "react";
import Button from "@material-ui/core/Button";
import BusinessIcon from "@material-ui/icons/Business";
import DataSourcesDialog from "src/components/loader/data_sources/DataSourcesDialog";

const DataSourcesButton = ({ handleClick, handleClosed, ...props }) => {
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    handleClosed();
  };
  return (
    <span>
      <Button
        variant="contained"
        color="primary"
        onClick={handleOpen}
        startIcon={<BusinessIcon />}
        style={{ padding: "4px 10px" }}
        {...props}
      >
        Data Sources
      </Button>
      <DataSourcesDialog open={open} handleClose={handleClose} />
    </span>
  );
};
export default DataSourcesButton;
